import PropTypes from 'prop-types';
import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'material-ui/DatePicker';
import DateTimeFormat from './DateTimeFormat';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

export default class MaterialDatePicker extends React.PureComponent {

    static displayName = '[PureComponent] MaterialDatePicker';

    constructor(props) {
        super(props);

        this.state = {
            currentDate: new Date()
        };
    }

    handleChangeDate = (event, date) => {
        this.setState({
            currentDate: date
        }, this.props.onChange(date.getTime(), this.props.id));
    };

    render() {
        const { minDate, maxDate, label, optionsStyle, value, id } = this.props;

        const muiTheme = getMuiTheme({
            datePicker: {
                headerColor: '#007254c9',
                selectColor: '#007254c9'
            },
            flatButton: {
                primaryTextColor: '#007254' }
        });

        return (
            <MuiThemeProvider muiTheme={muiTheme} >
                <DatePicker
                    id={id}
                    onChange={this.handleChangeDate}
                    floatingLabelText={label}
                    defaultDate={new Date()}
                    container="inline"
                    locale="ru"
                    cancelLabel="Отмена"
                    okLabel="Ок"
                    DateTimeFormat={DateTimeFormat}
                    minDate={minDate}
                    maxDate={maxDate}
                    textFieldStyle={optionsStyle}
                    value={value}
                />
            </MuiThemeProvider>
        );
    }

}

MaterialDatePicker.propTypes = {
    onChange    : PropTypes.func.isRequired,
    minDate     : PropTypes.object,
    maxDate     : PropTypes.object,
    label       : PropTypes.string,
    id          : PropTypes.string,
    optionsStyle: PropTypes.object,
    value       : PropTypes.object
};

MaterialDatePicker.defaultProps = {
    minDate     : new Date(1970, 1, 1),
    maxDate     : new Date(3000, 1, 1),
    label       : '',
    id          : '',
    optionsStyle: {},
    value       : new Date()
};



// WEBPACK FOOTER //
// ./src/blocks/date-picker/index.js